import Constants from '../constants';

const brandUtils = {
  isZillow(brand: string): boolean {
    return brand === Constants.UNFORMATTED_BRAND_NAMES.zillow;
  },
  isHotpads(brand: string): boolean {
    return brand === Constants.UNFORMATTED_BRAND_NAMES.hotpads;
  },
  isTrulia(brand: string): boolean {
    return brand === Constants.UNFORMATTED_BRAND_NAMES.trulia;
  },
  isSupportedBrand(brand: string): boolean {
    return brandUtils.isZillow(brand) || brandUtils.isHotpads(brand);
  },
};

export default brandUtils;
